module.exports = __webpack_public_path__ + "img/Animation.6a272680.gif";